import { apiAxiosCMS } from 'services/api';
import { RespTags } from 'types/PriceTagProps';
import { intialDataListTags } from './index';

// const respObj = {
// 	data: [
// 		{
// 			id: 'b6cccb6b-94da-4190-ac89-9320aaa81a6be',
// 			text: '10%OFF',
// 			vtex_cluster_id: '154',
// 			vtex_cluster_name: 'Vitrina 1 HOME',
// 			priority: 1,
// 			color: '#ffffff',
// 			font_size: null,
// 			location: null,
// 			background_color: '#565228',
// 			position: 'top',
// 			visible: false,
// 			file_id: null,
// 			created_at: '2025-01-14T12:05:55.121Z',
// 			updated_at: '2025-01-14T12:47:09.659Z',
// 			file: null
// 		},
// 		{
// 			id: 'b6cccb6b-94da-4190-ac89-9320saa81a6be',
// 			text: '10%OFF',
// 			vtex_cluster_id: '154',
// 			vtex_cluster_name: 'Vitrina 1 HOME',
// 			priority: 1,
// 			color: '#ffffff',
// 			font_size: null,
// 			location: null,
// 			background_color: '#aa0',
// 			position: 'top',
// 			visible: false,
// 			file_id: null,
// 			created_at: '2025-01-14T12:05:55.121Z',
// 			updated_at: '2025-01-14T12:47:09.659Z',
// 			file: null
// 		},
// 		{
// 			id: 'b6cccb6b-94da-4190-ac89-9320aa81a6e',
// 			text: '10%OFF',
// 			vtex_cluster_id: '154',
// 			vtex_cluster_name: 'Vitrina 1 HOME',
// 			priority: 1,
// 			color: '#ffffff',
// 			font_size: null,
// 			location: null,
// 			background_color: '#ffaaaa',
// 			position: 'top',
// 			visible: false,
// 			file_id: null,
// 			created_at: '2025-01-14T12:05:55.121Z',
// 			updated_at: '2025-01-14T12:47:09.659Z',
// 			file: null
// 		},
// 		{
// 			id: '1c63895b-4b98-4238-bc82-4cb71e204787',
// 			text: '',
// 			vtex_cluster_id: '154',
// 			vtex_cluster_name: 'Vitrina 1 HOME',
// 			priority: 1,
// 			color: '#ffffff',
// 			font_size: null,
// 			location: null,
// 			background_color: '#000',
// 			position: 'top',
// 			visible: true,
// 			file_id: '5880c5ca-1b5d-4826-a6f3-cd2d7f130100',
// 			created_at: '2025-01-14T12:46:50.707Z',
// 			updated_at: '2025-01-14T12:46:50.707Z',
// 			file: {
// 				id: '5880c5ca-1b5d-4826-a6f3-cd2d7f130100',
// 				name: '1736858794401-default--50-off.png',
// 				originalname: 'default--50-off.png',
// 				mimetype: 'image/png',
// 				size: 116123,
// 				key: null,
// 				relativePath: '/superxtra-dev/1736858794401-default--50-off.png',
// 				created_at: '2025-01-14T12:46:34.576Z',
// 				updated_at: '2025-01-14T12:46:34.576Z',
// 				url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-dev/1736858794401-default--50-off.png'
// 			}
// 		},
// 		{
// 			id: '2ce2042d-3aa0-4b1c-8947-a16d6379eeb5',
// 			text: 'Teste',
// 			vtex_cluster_id: '315',
// 			vtex_cluster_name: 'Home 1',
// 			priority: 1,
// 			color: '#ffffff',
// 			font_size: null,
// 			location: null,
// 			background_color: '#05eb20',
// 			position: 'bottom-left',
// 			visible: true,
// 			file_id: null,
// 			created_at: '2025-01-11T23:02:43.579Z',
// 			updated_at: '2025-01-14T12:16:48.635Z',
// 			file: null
// 		}
// 	],
// 	total: 3,
// 	page: 1,
// 	limit: 10,
// 	totalPages: 1
// };

interface GetTagsResp {
	isSuccess: boolean;
	data: RespTags;
}

export async function getTags(page: number, handleNotify: any) {
	const resp: GetTagsResp = { isSuccess: true, data: intialDataListTags };

	await apiAxiosCMS
		.get(`promotional-tags?page=${page}&limit=10`)
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch((error) => {
			handleNotify(error.message || 'Erro ao buscar as tags', 'error');
			resp.isSuccess = false;
			resp.data = intialDataListTags;
		});

	return resp;
}
